import {Component, Prop, Vue} from "vue-property-decorator";
import {Tab, Tabs} from "~/components/tabs";
import {namespace} from "vuex-class";

export enum UsersTab {
  UsersList,
  Groups
}

const usersManagementStore = namespace("usersManagement");

@Component
export class UsersNavigationTabs extends Vue {

  @usersManagementStore.Getter totalUsers:number;
  @usersManagementStore.Getter totalUsersFiltered:number;
  @usersManagementStore.Getter groupsCount:number;

  @Prop({type: Number, required: true}) value: UsersTab;

  renderUsersCount(){
    if( this.value === UsersTab.UsersList ){
      return this.totalUsers !== this.totalUsersFiltered ? `${this.totalUsersFiltered} / ${this.totalUsers}` :  this.totalUsers;
    } else {
      return this.totalUsers;
    }
  }

  render() {
    return (
      <Tabs>
        <Tab isActive={this.value === UsersTab.UsersList}
             onClick={() => this.$emit("input", UsersTab.UsersList)}>
            Utilisateurs {this.renderUsersCount()}
        </Tab>
        <Tab isActive={this.value === UsersTab.Groups}
             onClick={() => this.$emit("input", UsersTab.Groups)}>
          Groupes {this.groupsCount}
        </Tab>
      </Tabs>
    );
  }

}


// VUE JSX HOT LOADER //
if (module.hot) require("/usr/src/app/node_modules/vue-jsx-hot-loader/src/api.js")({ Vue: require('vue'), ctx: eval('this'), module: module, hotId: "_vue_jsx_hot-62c07f54/navigation-tabs.tsx" });